import { render, staticRenderFns } from "./error404.vue?vue&type=template&id=6049e26a&"
var script = {}
import style0 from "./error404.vue?vue&type=style&index=0&id=6049e26a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports